import {ITextContent} from "./ITextContent";
import {classToPlain, plainToClass, TransformFnParams} from "class-transformer";
import {ITextContentObject} from "./ITextContentObject";
import {SupportedLanguage} from "./SupportedLanguages";


export function toClassDocTextTransformFactory(targetClass: new () => ITextContent) {
	return (params: TransformFnParams) => {
		return toClassDocTextTransform({ plainObject: params.value, targetClass: targetClass });
	};
}


export function toClassDocTextTransform(data: { plainObject: object, targetClass: new() => ITextContent }) {
	// From object to object map
	let keys: Array<string> = Object.keys(data.plainObject);
	let returnObject: { [key: string]: ITextContent } = {};

	for (let iKey in keys) {
		let key: string = keys[iKey];
		let textContentPlain: any = data.plainObject[key];
		let textContent: ITextContent = plainToClass(data.targetClass, textContentPlain);
		returnObject[key] = textContent;
	}
	return returnObject;
}


export function toPlainDocTextTransform(params: TransformFnParams) {
	// From object map to a plain object map
	let keys: Array<string> = Object.keys(params.value);
	if (keys.indexOf("Clazz") != -1) {
		keys.splice(keys.indexOf("Clazz"), 1);
	}
	let returnObject: { [key: string]: {} } = {};

	for (let iKey in keys) {
		let key: string = keys[iKey];
		let textContent: ITextContent = params.value[key];
		let textContentPlain: any = classToPlain(textContent);
		returnObject[key] = textContentPlain;
	}
	return returnObject;
}
